import { render, staticRenderFns } from "./two-factor.vue?vue&type=template&id=edcc64f8&scoped=true&"
import script from "./two-factor.vue?vue&type=script&lang=ts&"
export * from "./two-factor.vue?vue&type=script&lang=ts&"
import style0 from "./two-factor.vue?vue&type=style&index=0&id=edcc64f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edcc64f8",
  null
  
)

export default component.exports